import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import "./Dialog.css";

const AlertDialog = ({ show, movie }) => {
  const [open, setOpen] = React.useState(show);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle className="dialog_box" id="alert-dialog-title">
          {movie?.name || movie?.original_title}
        </DialogTitle>
        <DialogContent className="dialog_box">
          <DialogContentText
            id="alert-dialog-description"
            className="dialog_box"
          >
            <h4>{movie?.overview}</h4>
            <h4>Popularity: {movie?.vote_average}</h4>
            <h5>Relase Date: {movie?.first_air_date || movie?.release_date}</h5>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog_box">
          <Button onClick={handleClose} color="secondary">
            BACK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AlertDialog;
